import { BASE } from './api.js';
import { jwtActual } from './auth.js';

export interface PerfilDeCuenta {
  readonly puedeEnviarEstudios?: boolean;
  readonly tieneHistorialEstudios?: boolean;
  readonly nivel: 'normal' | 'pro';
  readonly consentimientos: { readonly terminos: boolean; readonly newsletter: boolean };
  /**
   * ADMIN-02: `true` si nunca aceptó los términos vigentes, o si los aceptó en una versión
   * anterior a `VERSION_TERMINOS`. La API decide (compara con la versión vigente), no la web.
   */
  readonly terminosDesactualizados: boolean;
  /** ADMIN-01: si el email de la sesión está en `ADMIN_EMAILS` (la API lo decide, no la web). */
  readonly esAdmin: boolean;
}

/** `null` si no hay sesión o si no hay red: la pantalla trata los dos casos igual (no hay perfil que enseñar). */
export async function obtenerPerfil(token?: string): Promise<PerfilDeCuenta | null> {
  const jwt = token ?? (await jwtActual());
  if (jwt === null) return null;
  try {
    const r = await fetch(`${BASE}/cuentas/perfil`, { headers: { authorization: `Bearer ${jwt}` } });
    if (!r.ok) return null;
    return (await r.json()) as PerfilDeCuenta;
  } catch {
    return null;
  }
}

export interface ConsentimientoAGuardar {
  readonly tipo: 'terminos' | 'newsletter';
  readonly aceptado: boolean;
  readonly textoVersion: string;
  readonly texto: string;
}

/** `true` si se guardó. `false` si falló (sin sesión, sin red): quien llama decide qué decir. */
export async function guardarConsentimiento(entrada: ConsentimientoAGuardar, token?: string): Promise<boolean> {
  const jwt = token ?? (await jwtActual());
  if (jwt === null) return false;
  try {
    const r = await fetch(`${BASE}/cuentas/consentimientos`, {
      method: 'POST',
      headers: { authorization: `Bearer ${jwt}`, 'content-type': 'application/json' },
      body: JSON.stringify(entrada),
    });
    return r.ok;
  } catch {
    return false;
  }
}
